export default {
    features: state => state.features,
    assembled: state => state.assembled
}
